const theme = {
  colors: {
    primary: '#DE3238',
    secondary: '#3A0CA3',
    accent: '#F72585',
    background: '#F8F9FA',
    text: '#333333',
    lightText: '#6C757D',
    error: '#DC3545',
    success: '#28A745',
    warning: '#FFC107',
    info: '#17A2B8',
    white: '#FFFFFF',
    black: '#000000',
    gray100: '#F8F9FA',
    gray200: '#E9ECEF',
    gray300: '#DEE2E6',
    gray400: '#CED4DA',
    gray500: '#ADB5BD',
    gray600: '#6C757D',
    gray700: '#495057',
    gray800: '#343A40',
    gray900: '#465668',
  },
  
  fontSizes: {
    xxs: '0.625rem',    // 10px
    xs: '0.75rem',     // 12px
    sm: '0.875rem',    // 14px
    md: '1rem',        // 16px
    lg: '1.125rem',    // 18px
    xl: '1.25rem',     // 20px
    xxl: '1.5rem',     // 24px
    xxxl: '2rem',      // 32px
    xxxxl: '2.25rem',   // 40px
    xxxxxl: '2.5rem',    // 48px
  },
  
  fontWeights: {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '16px',
    circle: '50%',
  },
  
  spacing: {
    xs: '0.25rem',     // 4px
    sm: '0.5rem',      // 8px
    md: '1rem',        // 16px
    lg: '1.5rem',      // 24px
    xl: '2rem',        // 32px
    xxl: '3rem',       // 48px
  },
  
  // 모바일 우선 접근법: 기본은 모바일 크기, min-width 미디어 쿼리 사용
  breakpoints: {
    xs: '0px',
    sm: '576px',  // 작은 태블릿
    md: '768px',  // 태블릿
    lg: '992px',  // 작은 데스크탑
    xl: '1200px', // 데스크탑
    xxl: '1400px', // 큰 데스크탑
  },
  
  // 모바일 우선 미디어 쿼리 사용을 위한 헬퍼
  mediaQueries: {
    sm: `@media (min-width: 576px)`,
    md: `@media (min-width: 768px)`,
    lg: `@media (min-width: 992px)`,
    xl: `@media (min-width: 1200px)`,
    xxl: `@media (min-width: 1400px)`,
  },
  
  shadows: {
    small: '0 2px 4px rgba(0, 0, 0, 0.1)',
    medium: '0 4px 8px rgba(0, 0, 0, 0.1)',
    large: '0 8px 16px rgba(0, 0, 0, 0.1)',
  },
  
  transitions: {
    fast: '0.15s ease',
    normal: '0.3s ease',
    slow: '0.5s ease',
  },
};

export default theme; 